import { IsiPageRequestManagerResponse } from "./IsiPageRequestManagerResponse";

export class IsiPageRequestManagerRequest {

    IsiType: "POSTBACK" | "AJAX" | "COMPONENTEVENT";
    IsiArgs: IIsiPageRequestManagerRequestArgs;
    IsiId: string;
    IsiSender: any;
    IsiHttpMethod: "GET" | "POST";
    IsiUrl: string;
    IsiCallback: IIsiPageRequestManagerRequestCallback;
    IsiResponse: IsiPageRequestManagerResponse;
    IsiQueued: boolean;
    IsiErrorCallback: IIsiPageRequestManagerRequestCallback;
    IsiIsBlocking: boolean;
    JAjaxRequest: JQueryXHR;
    constructor(type, requestArgs, id, isBlocking) {
        // <summary>
        // Représente un évènement composant
        // </summary>
        // <param name="type">Type de requête</param>
        // <param name="requestArgs">Arguments de la requête.</param>
        // <history>
        // LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        // <history>
        this.IsiType = type;
        this.IsiArgs = requestArgs;
        this.IsiId = id;
        this.IsiSender = null;
        this.IsiHttpMethod = null;
        this.IsiUrl = null;
        this.IsiCallback = null;
        this.IsiResponse = new IsiPageRequestManagerResponse();
        this.IsiIsBlocking = isBlocking ? isBlocking : false;
       
    }
};

export interface IIsiPageRequestManagerRequestCallback {
    sender: any;
    componentId?: string;
    callback: (...args) => void;
    callbackParams: any;
    error?: any;
    eventArgs: any;
}

export interface IIsiPageRequestManagerRequestArgs {
    IsiRequestId?: string;
    IsiData: any;
    IsiEventName?: string;
}

export interface IIsiPageRequestManagerRequestCallbackArgs {
    callback: () => void;
    callbackParams?: any;
    errorCallback: () => void;
    errorCallbackParams?: any;
}